// src/components/ReadjudicacionMasiva/Dashboard/LoteTimeline.js

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Typography,
    Paper
} from '@mui/material';
import {
    Assignment as AssignmentIcon,
    RemoveCircle as RemoveCircleIcon,
    PersonAdd as PersonAddIcon,
    SwapHoriz as SwapHorizIcon,
    Print as PrintIcon,
    CheckCircle as CheckCircleIcon
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        padding: theme.spacing(3)
    },
    stepLabel: {
        '& .MuiStepLabel-label': {
            fontSize: '1rem',
            fontWeight: 500
        }
    },
    stepIcon: {
        color: theme.palette.primary.main
    },
    activeStep: {
        '& .MuiStepIcon-root': {
            color: theme.palette.primary.main
        }
    },
    completedStep: {
        '& .MuiStepIcon-root': {
            color: theme.palette.success.main
        }
    }
}));

const LoteTimeline = ({ estadoActual }) => {
    const classes = useStyles();

    const steps = [
        {
            label: 'Auditoría del Lote',
            description: 'Validar registros, corregir errores y asociar expediente administrativo',
            icon: <AssignmentIcon />,
            estado: 0
        },
        {
            label: 'Desapoderar Abogados',
            description: 'Cambiar carácter de abogados actuales a "Reemplazado"',
            icon: <RemoveCircleIcon />,
            estado: 1
        },
        {
            label: 'Asignar Nuevos Abogados',
            description: 'Asignar abogados a las causas del lote',
            icon: <PersonAddIcon />,
            estado: 2
        },
        {
            label: 'Pasaje a Ejecuciones',
            description: 'Pasar causas al sistema de ejecuciones',
            icon: <SwapHorizIcon />,
            estado: 3
        },
        {
            label: 'Generar Documentos',
            description: 'Imprimir carátulas, cartas poder, demandas, recibos y sobres',
            icon: <PrintIcon />,
            estado: 4
        },
        {
            label: 'Finalizado',
            description: 'Proceso completado exitosamente',
            icon: <CheckCircleIcon />,
            estado: 5
        }
    ];

    const getActiveStep = () => {
        const index = steps.findIndex(step => step.estado === estadoActual);
        return index >= 0 ? index : 0;
    };

    return (
        <Paper className={classes.paper}>
            <Typography variant="h6" gutterBottom>
                Flujo de Readjudicación Masiva
            </Typography>
            <Stepper activeStep={getActiveStep()} orientation="vertical" className={classes.root}>
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel className={classes.stepLabel}>
                            {step.label}
                        </StepLabel>
                        <StepContent>
                            <Typography variant="body2" color="text.secondary">
                                {step.description}
                            </Typography>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
        </Paper>
    );
};

export default LoteTimeline;
